// PhoneLine.phoneNumber зберігається нормалізованим — останні 9 цифр (див.
// back/src/utils/phone-normalize.util.js). Український мобільний номер — це
// завжди +380 + ці 9 цифр, тому формат виводу єдиний і без будь-якої
// евристики.
export function formatPhoneNumber(normalized) {
  if (!normalized) return '';
  return `+380${normalized}`;
}

// Для "сирих" номерів прямо з рахунку (rawPhoneNumber) — вони приходять у
// різних форматах залежно від оператора/джерела (380501605605, 0672540490,
// 486-69-29 тощо), нормалізуємо так само, як бекенд, для єдиного вигляду.
// Значення коротше 9 цифр — не телефон (рядок-послуга Vega несе номер
// особового рахунку, напр. "238019") — показуємо як є, без "+380".
export function formatRawPhoneNumber(raw) {
  if (!raw) return '';
  const digits = String(raw).replace(/\D/g, '');
  if (digits.length < 9) return String(raw);
  const normalized = digits.length > 9 ? digits.slice(-9) : digits;
  return formatPhoneNumber(normalized);
}

// Довідник заповнюється як "Прізвище Ім'я" (так само, як у старій Excel-таблиці:
// "Дягилев А.", "Шульга В.") — стискаємо до "Прізвище І." для компактних таблиць.
export function formatFio(fullName) {
  if (!fullName) return '';
  const parts = fullName.trim().split(/\s+/);
  if (parts.length < 2) return parts[0] || '';
  return `${parts[0]} ${parts[1][0]}.`;
}
